import { BoxIndicator } from '@classtinginc/design-system';
import loadable from '@loadable/component';

const ZoomIntegrationPageProxy = loadable(
  () => import('./ZoomIntegrationPageProxy'),
  {
    fallback: <BoxIndicator />,
  }
);

export default ZoomIntegrationPageProxy;
